const AOS = require('aos');
const { data } = require('jquery');
const $ = require('jquery');
// const _ = require('lodash');

require('@popperjs/core');
require('bootstrap');
require('slick-carousel');

window.jQuery = $;

$(function () {
  loadAOS();
  initSliders();
  initGoogleMapping();
  containerFix();
  submenuOffset();
  heroOffset();
  headerFix();
  checkWindowScroll();

  // handler for the resize window event
  $(window).on("resize", function () {
    containerFix();
    headerFix();
    submenuOffset();
  });
  // handler for the scroll window event
  $(window).on("scroll", function () {
    checkWindowScroll();
    uncoverElements();
  });

  function headerFix() {
    let header = $("header");
    let headerHeight = header.outerHeight();

    var firstSection = $('body').find('section').first();

    if (firstSection.hasClass('video-hero')) {
      firstSection.find('.container').css("margin-top", headerHeight + "px");
    } else {
      firstSection.css("margin-top", headerHeight + "px");
    }
  }

  $('section').each(function(){
    if($(this).hasClass('bg-secondary')){
      $(this).addClass('wysiwyg-white');
    } else {
      $(this).addClass('wysiwyg-secondary');
    }
  });

  // Mega Menu Tab Hover
  $('.tab-nav p').hover(function() {
    var index = $(this).data('index');
    $('.tab-menu').each(function() {
      var dataIndex = $(this).data('index');
      if (dataIndex != index) {
        $(this).addClass('d-none').removeClass('d-flex');
      } else {
        $(this).removeClass('d-none').addClass('d-flex');
      }
    });
  });

  // Search Toggle

  $('#desktop-search-button, #search-button').on('click', function(){
    $('#search-bar').toggleClass('active');
    $('#search-bar').find('.form-control').focus();
  });

  // Smooth scroll.
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .on("click", function (event) {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        var offset = $("header").outerHeight();
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top - offset,
            },
            1000
          );
        }
      }
    });

  // Burger click
  $("#burger").click(function () {
    open = !open;
    toggleMenu(open);
  });

  // Active class.
  $("header .nav [href]").each(function () {
    if (this.href == window.location.href) {
      $(this).addClass("active");
    }
  });

  // Submenu.
  $(".nav-item.parent-item").on("click", function () {
    var toggle = $(this);
    toggle.toggleClass("open");
    $(this).children(".submenu-toggle").toggleClass("open");
    var submenu = $(this).children(".submenu");
    submenu.toggleClass("open");
  });

  // Accordion Toggle
  $('.accordion-button').on('click', function(){
    console.log('working');
    $(this).closest('.accordion-item').toggleClass('active');
  });

  // Unset Filtering
  $('#unsetParamsButton').click(function(e) {
    e.preventDefault();
    // Redirect to the same URL without any GET parameters
    window.location.href = window.location.pathname;
  });

  function svgWysiwyg (sectionClass) {
    // Quote Marks -- Iterate over each .staff-feature .wysiwyg element
    $(sectionClass + ' .wysiwyg').each(function() {
      // Get starting and ending tag
      var firstInnerTag = $(this).children().first();
      var lastInnerTag = $(this).children().last();

      // Append the SVG inside the first inner HTML tag
      $(firstInnerTag).prepend('<svg width="52px" height="34px" viewBox="0 0 52 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="starting-quote" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M42.8854167,34 L27,34 L38.0677083,0 L52,0 L42.8854167,34 Z M0,34 L11.0677083,0 L25,0 L15.8854167,34 L0,34 Z" fill-rule="nonzero"></path></g></svg>');

      // Append the SVG inside the last paragraph tag
      $(lastInnerTag).append('<svg width="52px" height="34px" viewBox="0 0 52 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="ending-quote" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M42.8854167,34 L27,34 L38.0677083,0 L52,0 L42.8854167,34 Z M0,34 L11.0677083,0 L25,0 L15.8854167,34 L0,34 Z" fill-rule="nonzero"></path></g></svg>');
    });
  } 

  svgWysiwyg('.staff-feature');
  svgWysiwyg('.reviews-block');
  svgWysiwyg('.employee-testimonial');

  // Tasklite hover state
  $('.tasklite-hover').on('mouseenter', function(event) {
    let dataIndex = $(this).data('index');
    $('.tasklite-card').each(function() {
      if ($(this).data('index') == dataIndex) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      }
    });
  });

  // Modal Video
    $('.video-modal-btn').on('click', function(){
      var target = $(this).data('bs-target');
      $(target).find('video')[0].play();
    });

    $('.close-modal').on('click', function(){
      var target = $(this).data('current-modal');
      $(target).find('video')[0].pause();
      $(target).find('video')[0].currentTime = 0;
    });

  // Tab Hover
  function tabHover($tabClass, $tabContent ) {
    $($tabClass + ' .nav-link').on('mouseenter', function(event) {
      let dataIndex = $(this).data('index');
  
      $($tabContent + ' .tab-pane').each(function() {
        if ($(this).data('index') == dataIndex) {
          $(this).addClass('show');
          $(this).addClass('active');
        } else {
          $(this).removeClass('show');
          $(this).removeClass('active');
        }
      });
    });
  }
  
  tabHover('#chooseTab', '#chooseTabContent');
  tabHover('#growthTab', '#growthTabContent');

  // Toggle for side form
  
  $('#toggle-button').on('click', function(){
    $('.side-form-modal').toggleClass('active');
  });

  $.fn.isScrolledIntoView = function () {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(this).offset().top;
    return elemTop <= docViewBottom && elemTop >= docViewTop;
  };
});

/**
 * @description loads the AOS library after a set timeout
 */
let loadAOS = () => {
  setTimeout(() => {
    $("body").addClass("loaded");
    setTimeout(() => {
      AOS.init();
    }, 500);
  }, 1000);
};

/**
 * @description checks the scroll value of the window and adds a class to the header if the window is scrolled
 */
let checkWindowScroll = () => {
  let scroll = $(window).scrollTop();
  var firstSection = $('body').find('section').first();

  if (firstSection.hasClass('video-hero')) {
    if (scroll > 0) {
      $("header").addClass("scroll");
    } else {
      $("header").removeClass("scroll");
    }
  } else {
    $("header").addClass("scroll");
  }
};

/**
 * @description function for fixing floating elements or page width elements with content to the conventional bootstrap container sizes
 */
let containerFix = () => {
  if ($('.container-fix').length) {
    let containerWidths = {
      576: 540,
      768: 720,
      992: 960,
      1200: 1140,
      1440: 1440,
    };
    let windowWidth = $(window).width();
    let containerWidth = 0;
    for (const [key, value] of Object.entries(containerWidths)) {
      if (windowWidth >= key) {
        containerWidth = value;
      }
    }

    var padding = ((windowWidth - containerWidth) / 2) + 32;
    if (windowWidth >= 992) {
      $('.container-fix').each(function () {
        if ($(this).hasClass('odd')) {
          $(this).css('padding-left', '0px');
          $(this).css('padding-right', padding + 'px');
        } else if ($(this).hasClass('even')) {
          $(this).css('padding-left', padding + 'px');
          $(this).css('padding-right', '0px');
        }
      });
    } else if (windowWidth >= 576 && windowWidth <= 991) {
      $('.container-fix').each(function () {
        $(this).css('padding-left', padding + 'px');
        $(this).css('padding-right', padding + 'px');
      });
    } else {
      $('.container-fix').each(function () {
        $(this).css('padding-left', '32px');
        $(this).css('padding-right', '32px');
      });
    }
  }
};

/**
 *  @description affix appropriately css positioned elements (ie position = fixed || absolute) below the header banner
 */
 let submenuOffset = () => {
  let headerHeight = $("#header").outerHeight();
  let dropdown = $(".submenu.simple");
  let megamenu = $(".submenu.mega");
  let scroll = $(document).scrollTop();
  let topstripHeight = 0;
  let simpleMenu = headerHeight - 41;

  if ($('body').hasClass('logged-in') && $('body').hasClass('admin-bar')) {
    headerHeight = headerHeight + 32;
  } else {
    headerHeight = headerHeight;
  }

  if (scroll == 0) {
    dropdown.css("top", simpleMenu + "px");
    megamenu.css("top", headerHeight + "px");
  } else if (scroll < topstripHeight) {
    dropdown.css("top", scroll + simpleMenu + "px");
    megamenu.css("top", scroll + headerHeight + "px");
  } else {
    dropdown.css("top", simpleMenu + "px");
    megamenu.css("top", headerHeight + "px");
  }
};

/**
 * @description offset elements labeled with the offset hero class by the height of the header
 */
let heroOffset = () => {
  let hero = $(".offset-hero");
  let header = $("header");

  if (hero.length && header.length) {
    let height = $(header).outerHeight();
    $(hero).css("margin-top", `${height}px`);
  }
};

/**
 * @description reveals hidden page elements
 */
let uncoverElements = () => {
  $(".uncover").each(function () {
    if ($(this).isScrolledIntoView() === true) {
      $(this).addClass("show");
    }
  });
};

/**
 * @description initialise the slick sliders for the page
 */
let initSliders = () => {
  // generic slider example
  // go to - https://kenwheeler.github.io/slick/ - for documentation
  $(".slider").slick({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    slidesToShow: 1,
  });

  $(".reviews-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 15.5V10.7529L0.2898 10.6371L5.83309 8.39726C5.90239 8.36783 5.96186 8.31668 6.00376 8.25047C6.04566 8.18425 6.06807 8.10602 6.06807 8.02595C6.06807 7.94587 6.04566 7.86765 6.00376 7.80144C5.96186 7.73522 5.90239 7.68408 5.83309 7.65465L0.2898 5.37091L0 5.25113V0.5L0.616747 0.7675L12.6285 5.95781C12.7386 6.0057 12.8329 6.08798 12.8991 6.19402C12.9654 6.30006 13.0005 6.425 13 6.5527V9.45928C13.0005 9.58699 12.9654 9.71192 12.8991 9.81796C12.8329 9.924 12.7386 10.0063 12.6285 10.0542L0.616747 15.2445L0 15.5Z"/></svg></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 15.5V10.7529L0.2898 10.6371L5.83309 8.39726C5.90239 8.36783 5.96186 8.31668 6.00376 8.25047C6.04566 8.18425 6.06807 8.10602 6.06807 8.02595C6.06807 7.94587 6.04566 7.86765 6.00376 7.80144C5.96186 7.73522 5.90239 7.68408 5.83309 7.65465L0.2898 5.37091L0 5.25113V0.5L0.616747 0.7675L12.6285 5.95781C12.7386 6.0057 12.8329 6.08798 12.8991 6.19402C12.9654 6.30006 13.0005 6.425 13 6.5527V9.45928C13.0005 9.58699 12.9654 9.71192 12.8991 9.81796C12.8329 9.924 12.7386 10.0063 12.6285 10.0542L0.616747 15.2445L0 15.5Z"/></svg></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,
        }
      },
    ],
  });

  // slider arrow functionality
  // $('.slick-{arrow-name}.slick-prev').click(function () {
  //   $('.{carousel-name}').slick('slickPrev');
  // });
  // $('.slick-{arrow-name}.slick-next').click(function () {
  //   $('.{carousel-name}').slick('slickNext');
  // });
};

/**
 * @description handles opening and closing of the mobile menu on the site
 *
 * @param {*} open flag indicating whether or not the menu is in an open state
 */
var open = false;
let toggleMenu = (open) => {
  $("#burger").toggleClass("open", open);
  $("#navigation-mobile ul").toggleClass("open", open);
  $("#navigation-mobile .mobile-ctas").toggleClass("active", open);
  $("#search-bar").toggleClass("active", open);
};

/**
 * @description centers the map on the current marker or in the center of all markers present
 *
 * @param {*} map the JSON map object being worked on
 */
let centerMap = (map) => {
  let bounds = new google.maps.LatLngBounds();
  $.each(map.markers, function (i, marker) {
    let latlng = new google.maps.LatLng(
      marker.position.lat(),
      marker.position.lng()
    );
    bounds.extend(latlng);
  });
  if (map.markers.length == 1) {
    map.setCenter(bounds.getCenter());
    map.setZoom(map.zoom);
  } else {
    map.fitBounds(bounds);
  }
};

/**
 * @description adds a new marker to the map being created
 *
 * @param {*} $marker the jQuery HTML marker to be added
 * @param {*} map the JSON map object to be operated on
 */
let addMarker = ($marker, map) => {
  let latlng = new google.maps.LatLng(
    $marker.attr("data-lat"),
    $marker.attr("data-lng")
  );
  let icon = {
    url: "" + $marker.attr("data-icon") + "",
    scaledSize: new google.maps.Size(48, 48),
  };
  let marker = new google.maps.Marker({
    icon: icon,
    map: map,
    position: latlng,
  });
  map.markers.push(marker);
  if ($marker.html()) {
    let infowindow = new google.maps.InfoWindow({
      content: $marker.html(),
    });
    google.maps.event.addListener(marker, "click", function () {
      infowindow.open(map, marker);
    });
  }
};

/**
 * @description creates a new map at the location of the jQuery element passed in
 *
 * @param {*} $el the jQuery element to create a map aroudn
 */
let newMap = ($el) => {
  let $markers = $el.find(".marker");
  let args = {
    center: new google.maps.LatLng(0, 0),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    zoom: 12,
  };
  let map = new google.maps.Map($el[0], args);
  map.markers = [];
  $markers.each(function () {
    addMarker($(this), map);
  });
  centerMap(map);
  return map;
};

/**
 * @description convenience function for running all code required to generate a single (or multiple) maps on a page
 */
let initGoogleMapping = () => {
  $(".map").each(function () {
    newMap($(this));
  });
};
